import { render, staticRenderFns } from "./WorkerContactModal.vue?vue&type=template&id=dc9d0ae6"
import script from "./WorkerContactModal.vue?vue&type=script&lang=ts"
export * from "./WorkerContactModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports